import { fetchLabRemoteConfig } from 'actions/SystemActions'
import type { AppDispatch, AppStore } from 'src/client/store'

export default function initialiseLabRemoteConfig(
  store: AppStore,
  remoteConfigKeys: Array<string>,
): void {
  const dispatch = store.dispatch as AppDispatch
  dispatch(fetchLabRemoteConfig(remoteConfigKeys))
}
